// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1iWW6","col":"styles_col__2ftWE"};